import { loadModules } from "esri-loader";
import { kml, gpx } from "@tmcw/togeojson?module";
import Vue from "vue";

const getGenerateFeaturesRequestOptions = file => {
  return new Promise((resolve, reject) => {
    getGenerateFeaturesQueryFromFile(file)
      .then(generateFeaturesQuery => {
        let requestOptions = {
          query: generateFeaturesQuery,
          responseType: "json"
        };
        if (file.format !== "kml" && file.format !== "gpx") {
          requestOptions.body = file.formData;
        }
        resolve(requestOptions);
      })
      .catch(error => {
        reject(error);
      });
  });
};
const getGenerateFeaturesQueryFromFile = file => {
  return new Promise((resolve, reject) => {
    let params = getGenerateFeaturesPublishParams(file.name);
    let generateFeaturesQuery = {
      filetype: file.format,
      publishParameters: params,
      f: "json"
    };
    if (file.format === "gpx" || file.format === "kml") {
      readFileFormData(file)
        .then(formData => {
          generateFeaturesQuery.text =
            file.format === "gpx"
              ? parseGpxToGeoJSON(formData)
              : parseKmlToGeoJSON(formData);
          generateFeaturesQuery.filetype = "geojson";
          resolve(generateFeaturesQuery);
        })
        .catch(error => {
          reject(error);
        });
    } else {
      resolve(generateFeaturesQuery);
    }
  });
};
const getGenerateFeaturesPublishParams = featureSetName => {
  return JSON.stringify({
    name: featureSetName,
    targetSR: Vue.prototype.$theMapViewObject.spatialReference, // was
    maxRecordCount: 1000,
    enforceInputFileSizeLimit: true,
    enforceOutputJsonSizeLimit: true,
    generalize: false,
    maxAllowableOffset: 10,
    reducePrecision: false,
    numberOfDigitsAfterDecimal: 0
  });
};
const readFileFormData = file => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onerror = error => {
      reject(error);
    };
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.readAsText(file.formData);
  });
};
const parseGpxToGeoJSON = gpxString => {
  return JSON.stringify(
    gpx(new DOMParser().parseFromString(gpxString, "text/xml"))
  );
};
const parseKmlToGeoJSON = kmlString => {
  return JSON.stringify(
    kml(new DOMParser().parseFromString(kmlString, "text/xml"))
  );
};
const generateGraphics = options => {
  return new Promise((resolve, reject) => {
    loadModules(["esri/request"]).then(([esriRequest]) => {
      esriRequest(
        process.env.VUE_APP_GENERATE_FEATURES_SERVICE_URL,
        options.requestOptions
      )
        .then(response => {
          let featureCollection = response.data.featureCollection;

          let graphics = getGraphicsFromFeatureCollection(featureCollection);

          resolve(graphics);
        })
        .catch(error => {
          reject(error);
        });
    });
  });
};
const getGraphicsFromFeatureCollection = featureCollection => {
  let graphics = [];

  for (let i = 0; i < featureCollection.layers.length; i++) {
    for (
      let j = 0;
      j < featureCollection.layers[i].featureSet.features.length;
      j++
    ) {
      let feature = featureCollection.layers[i].featureSet.features[j];

      if (feature.hasOwnProperty("geometry")) {
        feature.symbol =
          featureCollection.layers[
            i
          ].layerDefinition.drawingInfo.renderer.symbol;
        graphics.push(feature);
      }
    }
  }
  return graphics;
};

export { getGenerateFeaturesRequestOptions, generateGraphics };
